import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { useGetTrapByTokenModalStore } from './GetTrapByTokenModalStore';
import GetTokenStep from './Steps/1_getTokenStep';
import ChooseTrapsStep from './Steps/2_chooseTraps';

import { PostDevicesToWarehouseRequest } from 'api/traps/DevicesWareHouse/types';

interface Props {
  refetchWarehouse: () => void;
}

const GetTrapByTokenModal: React.FC<Props> = ({ refetchWarehouse }) => {
  const { isOpen, onGetTrapByTokenModalClose } = useGetTrapByTokenModalStore();

  const [step, setStep] = useState(1);
  const [trapsList, setTrapsList] = useState<any[]>([]);
  const [selectedTraps, setSelectedTraps] = useState<PostDevicesToWarehouseRequest>({ trap_ids: [], hub_ids: [] });
  const [token, setToken] = useState<string>('');
  const onReset = () => {
    setStep(1);
    setTrapsList([]);
    setSelectedTraps({ trap_ids: [], hub_ids: [] });
    refetchWarehouse();
    onGetTrapByTokenModalClose();
  };

  const handleNextStep = () => {
    if (step === 1) {
      setStep(2);
    } else if (step === 2) {
      setStep(1);
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen} toggle={onReset} size={step === 1 ? 'md' : 'lg'}>
        <ModalHeader className="border-bottom py-3" toggle={onReset}>
          Add smart devices using token
        </ModalHeader>
        <ModalBody>
          {step === 1 && (
            <GetTokenStep onNext={handleNextStep} setTrapsList={setTrapsList} tokenTake={token} setToken={setToken} />
          )}
          {step === 2 && (
            <ChooseTrapsStep
              traps={trapsList}
              selectedTraps={selectedTraps}
              setSelectedTraps={setSelectedTraps}
              onReset={onReset}
              token={token}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default GetTrapByTokenModal;
